export enum AnimationSpeed {
    normal = 'normal',
    slow = 'slow',
    fast = 'fast'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/animation-speed.enum.ts